import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (!authService.getAccessToken()) {
    return router.parseUrl('/login');
  }

  const user = authService.currentUser();
  if (user?.force_password_reset === true) {
    const url = state.url?.split('?')[0] || '';
    if (!url.startsWith('/change-password')) {
      return router.parseUrl('/change-password');
    }
  }

  return true;
};
